import React from "react";

import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const useStyles = makeStyles()({
  title: {
    fontWeight: 600,
    fontSize: 18,
    lineHeight: 1,
    color: colors.dark,
  },
  subtitle: {
    fontSize: 14,
    lineHeight: "20px",
    color: colors.grey,
  },
});

const EmptyView: React.FC = () => {
  const { classes } = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      margin={2}
      alignItems="center"
      textAlign="center"
    >
      <div className={classes.title}>No clients to show</div>
      <div className={classes.subtitle}>
        Invite your clients now to start conversations
      </div>
    </Box>
  );
};

export default EmptyView;
